export default __webpack_public_path__ + "static/media/U.a0a50dcb.svg";